import React, { useState, useEffect } from "react";
import { AllSensorsDataContext } from "./context";

import { getAllSensorsData, getMoreAllSensors } from "../services/services";

const AllSensorsProvider = ({ children }) => {
  const [allSensorsData, setAllSensorsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const dummyMunicipalParkings = () => {
    const coordinates = [
      [20.9257778, 37.763],
      [20.8868584, 37.7782494],
      [20.900432, 37.776573],
      [20.900432, 37.776573],
      [20.89344, 37.7815352],
      [20.8945095, 37.7837134],
      [20.9207012, 37.7650211],
      [20.90064067627408, 37.77955044119991],
      [20.90027037670605, 37.7901703554918],
      [20.8711171, 37.8131379],
      [20.8740278, 37.8086111],
      [20.98623277644965, 37.70869297125969],
      [20.90519030432156, 37.7375959333637],
      [20.62671262163875, 37.86148354560928],
      [20.86349935165605, 37.71497511760946],
    ];

    const parkingSpots = coordinates.map(([lng, lat], index) => {
      const label = String(index + 1).padStart(3, "0");

      return {
        mysensor_id: `${100834 + index}`,
        ref_id: null,
        mysensor_name: `ΔΗΜΟΤΙΚΟ PARKING ${index + 1}`,
        sensor_description: "null",
        sensor_address: null,
        location_id: null,
        sensortype_id: "36",
        lat,
        lng,
        latlng: `${lat},${lng}`,
        location_name: null,
        location_lat: null,
        location_lng: null,
        sensortype_name: "Δημοτικά Πάρκινγκ",
        sensortype_color: "#FF006E",
        sensortype_icon: "im im im im-icon-Car-2",
        sensortype_description: "Ελεύθερες θέσεις για το PARKING",
        marker: "",
      };
    });

    return parkingSpots;
  };

  useEffect(() => {
    const fetchAllSensors = async () => {
      const AllSensors = await getAllSensorsData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            const tempParks = dummyMunicipalParkings();
            const datas = [
              ...response,
              {
                mysensor_id: "487",
                ref_id: null,
                mysensor_name: "Wifi Hotspot Πεζόδρομος Άλεξ. Ρώμα",
                sensor_description: "null",
                sensor_address: null,
                location_id: null,
                sensortype_id: "4",
                lat: "37.7849615",
                lng: "20.89703",
                latlng: "37.7849615,20.89703",
                location_name: null,
                location_lat: null,
                location_lng: null,
                sensortype_name: "Wifi Hotspots",
                sensortype_color: "#FF006E",
                sensortype_icon: "im im-icon-Wifi",
                sensortype_description:
                  "Δείτε απευθείας τα σημεία wifi hotspot της περιοχής",
                marker: "",
                metrics: [
                  {
                    content: "Κατάσταση",
                    value: "Ενεργό",
                  },
                ],
              },
              ...tempParks,
            ];
            return datas;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
          return [];
        });

      const tempAllSensors = {};

      for (let sensor of AllSensors) {
        if (tempAllSensors[sensor.sensortype_id] === undefined) {
          tempAllSensors[sensor.sensortype_id] = { data: [], filters: [] };
          // tempAllSensors[sensor.sensortype_id] = [];
        }
        tempAllSensors[sensor.sensortype_id].data.push(sensor);
      }

      const getMoreSensors = await getMoreAllSensors()
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return [
              ...response,
              {
                mysensor_id: "487",
                ref_id: null,
                mysensor_name: "Wifi Hotspot Πεζόδρομος Άλεξ. Ρώμα",
                sensor_description: "null",
                sensor_address: null,
                location_id: null,
                sensortype_id: "4",
                lat: "37.7849615",
                lng: "20.89703",
                latlng: "37.7849615,20.89703",
                location_name: null,
                location_lat: null,
                location_lng: null,
                sensortype_name: "Wifi Hotspots",
                sensortype_color: "#FF006E",
                sensortype_icon: "im im-icon-Wifi",
                sensortype_description:
                  "Δείτε απευθείας τα σημεία wifi hotspot της περιοχής",
                marker: "",
                metrics: [
                  {
                    content: "Κατάσταση",
                    value: "Ενεργό",
                  },
                ],
              },
            ];
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
          return [];
        });

      const wifiHotSpots = getMoreSensors.filter(
        (sensor) => sensor.sensortype_id === "4",
      );

      const pointsOfInterest = getMoreSensors.filter(
        (sensor) => sensor.sensortype_id === "7",
      );

      const benches = getMoreSensors.filter(
        (sensor) => sensor.sensortype_id === "30",
      );
      // const crossing = getMoreSensors.filter(
      //   (sensor) => sensor.sensortype_id === "32",
      // );

      tempAllSensors["4"] = wifiHotSpots;
      tempAllSensors["7"] = pointsOfInterest;
      tempAllSensors["30"] = benches;
      // tempAllSensors["32"] = crossing;

      tempAllSensors["31"]?.data.sort(
        (a, b) =>
          parseInt(a.mysensor_name.substring(22)) -
          parseInt(b.mysensor_name.substring(22)),
      );

      console.log("tempAllSensors:", tempAllSensors);

      setAllSensorsData(tempAllSensors);
    };

    fetchAllSensors();
  }, []);

  return (
    <AllSensorsDataContext.Provider
      value={{
        allSensorsData,
        setAllSensorsData,
        loading,
        error,
      }}
    >
      {children}
    </AllSensorsDataContext.Provider>
  );
};

export default AllSensorsProvider;
